import React from 'react';

import css from './sheet.module.css';

/** число с единицей измерения: единица мельче и серым, «30 футов» */
export const Measure: React.FC<{text: string}> = ({text}) => {
	const match = text.match(/^([\d/.,−-]+)\s+(\S.*)$/);
	if (!match) return <>{text}</>;
	return (
		<span className={css.measure}>
			{match[1]} <span className={css.measureUnit}>{match[2]}</span>
		</span>
	);
};
